@use '../../../../../../styles/Constants.scss' as Constants;
@use '../../../../../../styles/Colors.scss' as Colors;

.job-cell {
	background-color: Colors.$col-blueBackground;
	padding: Constants.$val-spacing-s;
	margin: Constants.$val-spacing-xs;
	font-weight: bold;
	color: Colors.$col-blue;
	display: flex;
	flex-direction: row;
	align-items: center;
}

.subjob-flag {
	padding-right: Constants.$val-spacing-s;
	padding-left: Constants.$val-spacing-s;
	margin: Constants.$val-spacing-xxs;
	color: Colors.$col-blue;
	background-color: Colors.$col-design-blue7;
	margin-right: Constants.$val-spacing-xs;
}